export default function showHeaderFooter () {
  const headerList = document.getElementsByTagName('header')
  const footerList = document.getElementsByTagName('footer')

  for (let i = 0; i < headerList.length; i++) {
    headerList.item(i).classList.remove('hide-element')
  }

  for (let i = 0; i < footerList.length; i++) {
    footerList.item(i).classList.remove('hide-element')
  }
}
